import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-voucher-searchmenu',
  templateUrl: './voucher-searchmenu.component.html',
  styleUrls: ['./voucher-searchmenu.component.css']
})
export class VoucherSearchmenuComponent implements OnInit {

  menuList:any;
  pageList:any;

  constructor() { }

  ngOnInit() {
    this.menuList=localStorage.getItem('menuList');
    this.menuList=JSON.parse(this.menuList);
    for(let i=0; i<this.menuList.length; i++){
      if(this.menuList[i].KHB_MenuName=='Help')
        this.pageList=this.menuList[i].KHB_PagesList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/help/voucher-searchmenu/voucher-searchmenu.component.ts